import { render, staticRenderFns } from "./cabinet-transactions-list.vue?vue&type=template&id=08b8ca42&scoped=true"
import script from "./cabinet-transactions-list.vue?vue&type=script&lang=js"
export * from "./cabinet-transactions-list.vue?vue&type=script&lang=js"
import style0 from "./cabinet-transactions-list.vue?vue&type=style&index=0&id=08b8ca42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b8ca42",
  null
  
)

export default component.exports